import { DatasetStore } from "../../../dataset-store/dataset-store";

export interface PickFieldProps<V = any> {
  values: V[];
  count: PickCount;
}

export type PickCount = number | PickCountLimits | PickCountFunction;

export type PickCountLimits = { min?: number; max?: number };

export type PickCountFunction = (
  props: PickCountFunctionProps,
) => number | PickCountLimits | Promise<number | PickCountLimits>;

export type PickCountFunctionProps<C = any> = {
  /** Current schema document fields */
  currentFields: C;
  /** Store to interact with all dataset schemas */
  store: DatasetStore;
};

export class PickField<V = any> {
  constructor(readonly values: PickFieldProps<V>) {}
}
